import { PublicEnterpriseTenant } from "@/types/enterprise-tenant";

export const ENTERPRISE_TENANTS: Record<string, PublicEnterpriseTenant> = {
  "konacalls.com": {
    favicon: "/logos/kona-favicon.png",
    logoUrl: "/logos/kona-logo.png",
    host: "konacalls.com",
    websiteUrl: "https://konamedicalconsulting.com/",
    name: "Kona Medical",
    description:
      "Kona Medical is a healthcare clinic that provides medical consulting services. Kona provides highly advanced AI to streamline clinical services and operations.",
  },
  "decodahealth.com": {
    favicon: "/logos/decoda-favicon.ico",
    logoUrl: "/logos/decoda-logo.png",
    host: "decodahealth.com",
    websiteUrl: "https://decodahealth.com/",
    name: "Decoda Health",
    description:
      "Decoda Health centralizes communications between healthcare clinics and patients along with a comprehensive payments platform. Our platform makes it easy for patients to communicate with their healthcare providers and pay for services all in one place.",
  },
  "createmore.us": {
    favicon: "/logos/decoda-favicon.ico",
    logoUrl: "/logos/createmore-logo.jpg",
    host: "createmore.us",
    websiteUrl: "https://createmore.us/",
    name: "Create More US",
    description:
      "Create More provides a platform for healthcare providers to manage their patients and provide them with the best care possible.",
  },
  "klaim.com": {
    favicon: "/logos/klaim-favicon.ico",
    logoUrl: "/logos/klaim-logo.png",
    host: "klaim.com",
    websiteUrl: "https://klaim.com/",
    name: "Klaim",
    description: "We turn your patient care Claims to cash in 24 hours!",
  },
  "rivasweightloss.com": {
    favicon: "/logos/rivas-favicon.jpg",
    logoUrl: "/logos/rivas-logo.png",
    host: "rivasweightloss.com",
    websiteUrl: "https://rivasweightloss.com/",
    name: "Rivas Weight Loss",
    description:
      "Rivas Weight Loss is a healthcare platform that provides a comprehensive suite of tools for healthcare providers to manage their patients and provide them with the best care possible.",
  },
};
